function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

import { useRef, useEffect } from 'react';
export var noop = function noop() {};
export var minuteDuration = function minuteDuration(second) {
  var secNum = parseInt(second, 10);
  var hours = Math.floor(secNum / 3600);
  var minutes = Math.floor((secNum - hours * 3600) / 60);
  var seconds = secNum - hours * 3600 - minutes * 60;

  if (minutes < 10) {
    minutes = '0' + minutes;
  }

  if (seconds < 10) {
    seconds = '0' + seconds;
  }

  return minutes + ":" + seconds + " \u0E19\u0E32\u0E17\u0E35";
};
export var useInterval = function useInterval(callback, delay) {
  var savedCallback = useRef();
  useEffect(function () {
    savedCallback.current = callback;
  });
  useEffect(function () {
    function tick() {
      savedCallback.current();
    }

    if (delay !== null) {
      var id_1 = setInterval(tick, delay);
      return function () {
        return clearInterval(id_1);
      };
    }
  }, [delay]);
};
export function isArray(value) {
  return Array.isArray(value);
}
export var isObject = function isObject(value) {
  var type = _typeof(value);

  return value != null && (type === 'object' || type === 'function') && !isArray(value);
};
export var isEmptyObject = function isEmptyObject(value) {
  return isObject(value) && Object.keys(value).length === 0;
};
export var formatNumber = function formatNumber(value) {
  return value.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
};